export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./playthrough.vue?vue&type=template&id=5932e059&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bonuses/playthrough.vue?vue&type=template&id=5932e059&scoped=true
// module id = JLKA
// module chunks = 0